<template>
  <div class="page-content">
    <el-row class="sign-manage-title search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">自定义菜单</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div">
        <el-form :model="formInline" :rules="rules" ref="formInline" label-width="100px" class="box-content-form">
          <el-form-item label="菜单名称:" prop='name' style="margin-left: 270px">
            <el-input v-model="formInline.name" placeholder="请输入菜单名称"></el-input>
          </el-form-item>
          <el-form-item label="上级分类:" style="margin-left: 270px">
            <el-select v-model="formInline.pid" placeholder="请选择上级分类">
              <el-option v-for="item in menutypeOptions" :key="item.id" :label="item.keyword" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="按钮类型:" prop="menutype" style="margin-left: 270px">
            <el-select v-model="formInline.menutype" placeholder="请选择按钮类型">
              <el-option v-for="item in menutypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <ul class="Reply">
            <li @click="replyText = true">
              <img src="../../assets/images/1.png" alt="">
            </li>
            <li @click="replyMarketing = true">
              <img src="../../assets/images/2.png" alt="">
            </li>
            <li @click="replyPicture = true">
              <img src="../../assets/images/3.png" alt="">
            </li>
            <li @click="replyPage = true">
              <img src="../../assets/images/4.png" alt="">
            </li>
            <!-- <li @click="replyModules = true">
              <img src="../../assets/images/6.png" alt="">
            </li> -->
          </ul>
          <el-form-item :label="ReplyTit" v-if='ReplyCon' style='text-align: left;margin-left: 270px'>
            <span style="text-align:left;display: inline-block;width: 100%;" v-if='type != 13'>{{ReplyContent}}</span>
            <img :src="replypic" style="width:100px" v-if='type == 13'>
          </el-form-item>
          <el-form-item label="" style="text-align: left;width: 100%;margin-top: 93px">
            <el-button class="second-page-btn-back reply-btn-type-goback"
              style="float: none;margin-left: 248px;margin-right:32px;" @click='goBack'>返回</el-button>
            <el-button class="second-page-btn reply-btn-type" type="primary" style="float: none;"
              @click="editMenuApi('formInline')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <!-- 关键词弹窗 -->
    <el-dialog class="cellDialog" title="添加回复文字" :visible.sync="replyText" width="30%">
      <el-input type="textarea" :rows="5" placeholder="请输入回复文字" v-model="text">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyText = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="ReplyTrue('显示文字:',text,1)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 微营销回复 -->
    <el-dialog class="cellDialog" title="选择微营销" :visible.sync="replyMarketing" width="500px">
      <el-select v-model="reply_id" filterable placeholder="可输入查询微营销" style="width: 280px">
        <el-option v-for="item in marketingList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyMarketing = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="ReplyTrue('弹出微营销:',reply_id,6)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片回复 -->
    <el-dialog class="cellDialog" title="上传图片" :visible.sync="replyPicture" width="500px">
      <el-upload class="reply-avatar-uploader-icon" list-type="picture-card" :show-file-list="false" :action="upload"
        name="file_upload" :before-upload="beforeAvatarUpload" :on-success="thumbSuccess">
        <div v-if="replypic" class="opacity-div">
          <img :src="replypic" class="interest-image">
          <div class="back-div">点击更换</div>
        </div>
        <div v-if="replypic === ''" slot="tip" style="line-height:20px;color:#606266; margin-top: 10px;">
          请选择1M以下，支持上传jpg/png文件</div>
        <img v-if="replypic === ''" src="../../assets/images/Group.png" class="default-images">
      </el-upload>
      <!-- <p>必填！建议尺寸250x140</p> -->
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyPicture = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="ReplyTrue('显示图片:',replypic,13)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 微页面回复 -->
    <el-dialog class="cellDialog" title="选择微页面" :visible.sync="replyPage" width="500px">
      <el-select v-model="page_reply_id" filterable placeholder="可输入查询微页面" style="width: 280px">
        <el-option v-for="item in MicroPage" :key="item.id" :label="item.admin_title" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyPage = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="ReplyTrue('弹出微页面:',page_reply_id,14)">确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 模块回复 -->
    <el-dialog class="cellDialog" title="选择模块" :visible.sync="replyModules" width="500px">
      <el-select v-model="module_reply_id" filterable placeholder="可输入查询模块" style="width: 280px">
        <el-option v-for="item in modules" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyModules = false">取 消</el-button>
        <el-button type="primary" class="dialog-confirm-btn" @click="ReplyTrue('回复:',module_reply_id,module_reply_id)">确
          定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { getWePagesListForNode, WePagesList, editMenuApi, editMenuDetail, ActivityList, MenuList } from '@/api/customer.js'
export default {
  name: 'ReplyKeyWordAdd',
  data () {
    return {
      id: this.$route.query.id,
      public_id: this.$route.query.public_id,
      formInline: {
        original_id: this.$route.query.original_id,
        name: '',
        pid: null,
        menutype: null
      },
      rules: {
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        menutype: [
          { required: true, message: '请选择按钮类型', trigger: 'change' }
        ]
      },
      menutypeOptions: [], // 上级分类
      menutypeList: [{
        value: 1,
        label: '点击(click)'
      }, {
        value: 2,
        label: '跳转(view)'
      }], // 按钮类型
      modules: [
        // {id: 15, name: '会员注册'},
        { id: 16, name: '线下活动' }
      ],
      module_reply_id: '',
      replyModules: false, // 回复模块
      replyText: false, // 回复弹窗--文字
      replyMarketing: false, // 营销
      replyPicture: false, // 图片
      replyPage: false, // 微页面
      MicroPage: [], // 微页面列表
      marketingList: [], // 微营销列表
      type: null,
      text: '',
      replypic: '',
      imgName: '',
      API_HOST: API_HOST,
      reply_id: '',
      page_reply_id: '',
      ReplyCon: false,
      ReplyTit: '',
      ReplyContent: ''
    }
  },
  computed: {
    upload () {
      // console.log(window.HOST)
      return API_HOST + '/admin/Upload/upload'
    }
  },
  mounted () {
    this.marketingListApi()
    this.microListApi()
    this.MenuList()
    if (typeof (this.id) !== 'undefined') {
      this.getById()
    }
  },
  methods: {
    beforeAvatarUpload (file) {
      _g.toastMsg('success', '正在上传')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        _g.toastMsg('上传图片只能是 JPG/PNG 格式!')
      }
      return (isJPG) || (isPNG)
    },
    // 上级分类
    MenuList () {
      MenuList().then((res) => {
        console.log(res)
        this.menutypeOptions = res.data.data.parent
      })
    },
    // 微营销
    marketingListApi () {
      let data = {
        search: {
          public_id: this.public_id,
          status: 1
        }
      }
      ActivityList(data).then((res) => {
        if (res.data.code === 0) {
          this.marketingList = res.data.data.list
          let flag = 0
          this.marketingList.some(item => {
            if (item.id !== this.reply_id) {
              flag++
            }
            if (flag === this.marketingList.length) {
              this.reply_id = ''
            }
          })
        }
      })
    },
    // 微页面
    microListApi () {
      let data = {
        search: {
          public_id: this.public_id,
          publish_status: 1
        }
      }
      WePagesList(data).then((res) => {
        if (res.data.code === 0) {
          for (let item of res.data.data.list) {
            item.id = item.id + ''
          }
          this.MicroPage = res.data.data.list
          let flag = 0
          this.MicroPage.some(item => {
            if (item.id !== this.page_reply_id) {
              flag++
            }
            if (flag === this.MicroPage.length) {
              this.page_reply_id = ''
            }
          })
        }
      })
    },
    // 获取详情
    getById () {
      let data = {
        id: this.id
      }
      editMenuDetail(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res)
          let info = res.data.data.menuInfo
          let replydata = res.data.replydata
          this.formInline.name = info.keyword
          this.formInline.pid = info.pid
          this.formInline.menutype = info.menutype
          if (info.type === 1) {
            this.ReplyTrue('显示文字:', replydata.text, 1)
            this.text = replydata.text
          } else if (info.type === 6) {
            this.ReplyTrue('弹出微营销:', replydata.title, info.type, 1)
            this.reply_id = replydata.lottery_id
          } else if (info.type === 13) {
            this.ReplyTrue('显示图片:', replydata.picture, info.type)
          } else if (info.type === 14) {
            this.ReplyTrue('弹出微页面:', replydata.title, info.type, 1)
            this.page_reply_id = replydata.scene_id
          } else if (info.type === 15) {
            this.ReplyTrue('回复:', '会员注册', info.type)
          } else if (info.type === 16) {
            this.ReplyTrue('回复:', '线下活动', info.type)
          }
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    thumbSuccess (response, file, fileList) {
      this.replypic = response.data.path
      this.imgName = file.name
    },
    // 添加和编辑
    editMenuApi (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            type: this.type,
            name: this.formInline.name,
            pid: this.formInline.pid,
            menutype: this.formInline.menutype,
            original_id: this.formInline.original_id,
            msgtype: 4
          }
          let status
          if (typeof (this.id) !== 'undefined') {
            data.id = this.id
            status = 1
          } else {
            status = 2
          }
          if (this.type === 1) {
            data.text = this.text
          } else if (this.type === 6) {
            data.reply_id = this.reply_id
            data.lottery_type = 'l'
          } else if (this.type === 13) {
            data.img = this.imgName
            data.picture = this.replypic
          } else if (this.type === 14) {
            data.reply_id = this.page_reply_id
          }
          editMenuApi(data, status).then((res) => {
            if (res.data.code === 0) {
              console.log(res)
              if (typeof (this.id) !== 'undefined') {
                _g.toastMsg('success', '编辑成功')
              } else {
                _g.toastMsg('success', '添加成功')
              }
              this.goBack()
            } else {
              _g.toastMsg('error', res.data.error)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    ReplyTrue (title, con, type, status) {
      if (type === 15) {
        con = '会员注册'
      }
      if (type == 16) {
        con = '线下活动'
      }
      if (status === 1) {
        if (type === 13) {
          this.replypic = con
        } else {
          this.ReplyContent = con
        }
      } else {
        if (type === 14) { // 微页面
          if (con === '') {
            _g.toastMsg('error', '请选择微页面')
            return
          }
          for (let item of this.MicroPage) {
            if (item.id == con) {
              this.ReplyContent = item.admin_title
            }
          }
        } else if (type === 6) { // 微营销
          if (con === '') {
            _g.toastMsg('error', '请选择微营销')
            return
          }
          for (let item of this.marketingList) {
            if (item.id == con) {
              this.ReplyContent = item.name
            }
          }
        } else if (type === 13) { // 显示图片
          if (con === '') {
            _g.toastMsg('error', '请上传图片')
            return
          }
          this.replypic = con
        } else if (type === 1) { // 文字
          if (con === '') {
            _g.toastMsg('error', '请输入回复文字')
            return
          }
          this.ReplyContent = con
        } else {
          if (con === '') {
            _g.toastMsg('error', '请选择模块')
            return
          }
          this.ReplyContent = con
        }
      }
      this.type = type
      this.ReplyTit = title
      this.ReplyCon = true
      this.replyText = false // 回复弹窗--文字
      this.replyMarketing = false // 营销
      this.replyPicture = false // 图片
      this.replyPage = false
      this.replyModules = false
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  created () {
  }
}
</script>

<style scoped>
.green {
  color: green;
}
.red {
  color: red;
}
.add-btn {
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 800px;
  margin: auto;
}
.box-content-form {
  margin-top: 10px;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 300px;
}

.avatar-uploader {
  border: 1px #d9d9d9 dashed;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  margin: 0 auto;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.Reply {
  height: 100px;
}
.Reply li {
  width: 130px;
  height: 130px;
  margin-right: 20px;
  border-radius: 5px;
  float: left;
  list-style: none;
  cursor: pointer;
  margin-bottom: 20px;
}
.Reply li i {
  font-size: 40px;
  margin: 20px 0 8px 0;
}
.Reply li span {
  display: block;
  font-size: 14px;
}
.Reply li:hover {
  color: #ff9b00;
}
.replyMarketing {
  position: relative;
  top: -20px;
  height: 292px;
  text-align: left;
  padding-left: 20px;
}
.page {
  position: absolute;
  bottom: -44px;
  right: 0;
}

.interest-image {
  display: inline-block;
  width: 148px;
  height: 148px;
  position: relative;
}
.opacity-div {
  width: 148px;
  height: 148px;
  position: relative;
}
.opacity-div:hover .back-div {
  opacity: 1 !important;
}
.back-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  height: 148px;
  width: 148px;
  top: 0px;
  left: 1px;
  opacity: 0;
  cursor: pointer;
  color: #fff;
  line-height: 148px;
}
.default-images {
  width: 148px;
}
.interest-uploader {
  width: 148px;
  height: 148px;
}
</style>
